import { format } from "date-fns";

export class UiHelper {
    static currencyFormatter(currencyValue: string | number | undefined, currency?: CurrencyType): string {
        if (!currencyValue) {
            return "";
        }
        let tempCurrencyValue = typeof currencyValue == "string" ? Number(currencyValue) : currencyValue;
        let formattedValue;
        if (currency) {
            formattedValue = new Intl.NumberFormat("en-GB", {
                style: "currency",
                currency: currency,
            }).format(tempCurrencyValue);
        } else {
            formattedValue = new Intl.NumberFormat("en-GB", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            }).format(tempCurrencyValue);
        }
        return formattedValue;
    }

    static displayDateFormat(date: Date | string): string {
        if (typeof date === "string") {
            return format(new Date(date), "dd MMM yyyy");
        }
        return format(date, "dd MMM yyyy");
    }

    

    static formatSemiColonSeparatedStringToList = (rolesString: string) => {
        if (!rolesString || rolesString.length === 0) {
            return [];
        }
        return rolesString.split(";");
    };

    static getCurrencySymbol(locale: string, currency: string) {
        return (0)
            .toLocaleString(locale, {
                style: "currency",
                currency: currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            })
            .replace(/\d/g, "")
            .trim();
    }

    static customMoneyFormatter(value: number, decimalPlaces?: number): string {
        if (!value) {
            return "";
        }        
        if (!decimalPlaces) {
            decimalPlaces = 0;
        }
        let formattedValue;
        formattedValue = new Intl.NumberFormat("en-GB", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(value);
        return formattedValue;
    }

    static createConcatenatedLabelFromObject(camelCaseLabel: string[], item: any): string {
        let tempFooterLabel: string = "";
        for (let i = 0; i < camelCaseLabel.length; i++) {
            const element = camelCaseLabel[i];
            const label = item[element];
            if (!label) {
                continue;
            }
            tempFooterLabel += label + ", ";
        }
        tempFooterLabel = tempFooterLabel.slice(0, tempFooterLabel.length - 2);
        return tempFooterLabel;
    }

    static convertFirstLetterToLowercase(word: string): string {
        if (typeof word !== "string" || word.length === 0) {
            return word; // Return the word as is if it's not a string or empty
        }

        const firstLetter = word.charAt(0).toLowerCase(); // Extract the first letter and convert it to lowercase
        const restOfWord = word.slice(1); // Get the rest of the word

        return firstLetter + restOfWord; // Concatenate the modified first letter with the rest of the word
    }

    static isDefaultDate(date: Date | string): boolean {
        if (!date) {
            return false;
        }

        if (this.displayDateFormat(date).toUpperCase() == "01 JAN 1900") {
            return true;
        }
        return false;
    }

    static getDefaultDate(): Date {
        return new Date("1900-01-01");
    }

    static getDefaultDateString(): string {
        return format(this.getDefaultDate(), "yyyy-MM-dd");
    }    
}

export type CurrencyType = "USD" | "GBP" | "EUR" | "CAD" | "AUD";
